import React from 'react';
import { motion } from 'framer-motion';

/**
 * Video Demo Section - Shows the product in action
 *
 * @param {Object} props
 * @param {string} props.videoUrl - YouTube embed URL
 * @param {string} props.title - Video title for accessibility
 * @param {number} props.delay - Animation delay (default: 0)
 */
const VideoDemo = ({
  videoUrl = 'https://www.youtube.com/embed/RYUz7Ym1ZXU',
  title = 'BibeCheck Demo',
  delay = 0
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      className="max-w-5xl mx-auto mb-8"
    >
      <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
        <iframe
          width="100%"
          height="100%"
          src={videoUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full border-0"
        ></iframe>
      </div>
    </motion.div>
  );
};

export default VideoDemo;
